// import React from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Typography,
//   Button,
//   Alert,
//   Paper,
//   Box,
//   CircularProgress,
//   FormControl,
//   FormLabel,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
// } from "@mui/material";
// import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import CreditCardIcon from "@mui/icons-material/CreditCard";
// import ReceiptIcon from "@mui/icons-material/Receipt";
// import PaymentBreakdown from "../../../components/PaymentBreakdown";
// import {
//   calculateAdvanceAndRentCommission,
//   calculateAdvancePayment,
//   formatCurrency,
// } from "../../../utils/commissionCalculator";
// import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// import { IconButton } from "@mui/material";
// import { toast, ToastContainer } from "react-toastify";
// import { Stack } from '@mui/material';
// import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
// import CancelIcon from '@mui/icons-material/Cancel';
// import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';

// const PaymentDialog = ({
//   open,
//   request,
//   paymentMethod,
//   onPaymentMethodChange,
//   receiptImage,
//   receiptPreview,
//   onReceiptUpload,
//   paymentError,
//   paymentLoading,
//   settingsLoaded,
//   settingsLoading,
//   customRates,
//   onClose,
//   onPayWithSafePay,
//   onPayWithAlfa,
//   onSubmitReceipt,
// }) => {
//   if (!request) return null;

//   const advanceAmount = Number(request?.flatAdvance || 0);
//   const rentAmount = Number(request?.flatRent || 0);
//   const advanceBreakdown = calculateAdvanceAndRentCommission(
//     advanceAmount,
//     rentAmount,
//     customRates
//   );
//   // const grandTotal = advanceBreakdown.totalTenantPays + advanceAmount;
//   const grandTotal = advanceBreakdown.totalTenantPays;

//   const copyToClipboard = (text) => {
//     toast.success("Copied!");
//     navigator.clipboard.writeText(text);
//   };
//   return (
//     <>
//       <Dialog
//         open={open}
//         onClose={onClose}
//         maxWidth="sm"
//         fullWidth
//         PaperProps={{
//           sx: {
//             borderRadius: 3,
//           },
//         }}
//       >
//         <DialogTitle sx={{ pb: 1 }}>
//           <Typography variant="h6" fontWeight={700}>
//             Make Payment
//           </Typography>
//         </DialogTitle>
//         <DialogContent>
//           {paymentError && (
//             <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>
//               {paymentError}
//             </Alert>
//           )}

//           {/* Flat Info */}
//           <Paper
//             elevation={0}
//             sx={{ bgcolor: "#f5f5f5", p: 2, borderRadius: 2, mb: 3 }}
//           >
//             <Typography variant="subtitle1" fontWeight={600}>
//               {request?.flatName}
//             </Typography>
//           </Paper>

//           {/* Loading indicator */}
//           {(!settingsLoaded || settingsLoading) && (
//             <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
//               <CircularProgress />
//             </Box>
//           )}

//           {/* Payment Breakdown */}
//           {settingsLoaded && !settingsLoading && (
//             <Box sx={{ mb: 3 }}>
//               <PaymentBreakdown
//                 baseAmount={advanceAmount}
//                 commissionAmount={advanceBreakdown.commissionAmount}
//                 commissionPercentage={advanceBreakdown.commissionPercentage}
//                 lateFee={0}
//                 totalAmount={advanceBreakdown.totalTenantPays}
//                 landlordReceives={advanceBreakdown.landlordReceives}
//                 type="advance"
//                 isLate={false}
//                 daysOverdue={0}
//                 paymentMethod={paymentMethod}
//               />

//               <Paper
//                 elevation={0}
//                 sx={{
//                   border: "1px solid #e0e0e0",
//                   borderRadius: 2,
//                   p: 2,
//                   mt: 2,
//                 }}
//               >
//                 <Box
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                   }}
//                 >
//                   <Typography variant="body1">First Month Rent</Typography>
//                   <Typography variant="body1" fontWeight={600}>
//                     {formatCurrency(rentAmount)}
//                   </Typography>
//                 </Box>
//               </Paper>

//               {paymentMethod === "safepay" && (
//                 <Paper
//                   elevation={0}
//                   sx={{
//                     border: "1px solid #e0e0e0",
//                     borderRadius: 2,
//                     p: 2,
//                     mt: 2,
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center",
//                     }}
//                   >
//                     <Typography variant="body1">
//                       SafePay Processing Fee
//                     </Typography>
//                     <Typography variant="body1" fontWeight={600}>
//                       3.28%
//                     </Typography>
//                   </Box>
//                 </Paper>
//               )}
//               {paymentMethod === "alfa" && (
//                 <Paper
//                   elevation={0}
//                   sx={{
//                     border: "1px solid #e0e0e0",
//                     borderRadius: 2,
//                     p: 2,
//                     mt: 2,
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center",
//                     }}
//                   >
//                     <Typography variant="body1">Alfa Processing Fee</Typography>
//                     <Typography variant="body1" fontWeight={600}>
//                       2.5%
//                     </Typography>
//                   </Box>
//                 </Paper>
//               )}

//               <Paper
//                 elevation={0}
//                 sx={{
//                   bgcolor: "primary.main",
//                   color: "white",
//                   p: 2,
//                   borderRadius: 2,
//                   mt: 2,
//                 }}
//               >
//                 <Box
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                   }}
//                 >
//                   <Typography variant="h6" fontWeight={600}>
//                     Grand Total
//                   </Typography>
//                   <Typography variant="h5" fontWeight={700}>
//                     {formatCurrency(
//                       paymentMethod === "safepay"
//                         ? Math.ceil(grandTotal / 0.9672)
//                         : paymentMethod === "alfa"
//                         ? Math.ceil(grandTotal + grandTotal * 0.025)
//                         : grandTotal
//                     )}
//                   </Typography>
//                 </Box>
//               </Paper>
//             </Box>
//           )}

//           {/* Payment Method Selection */}
//           <FormControl component="fieldset" sx={{ mb: 3 }}>
//             <FormLabel component="legend">Choose Payment Method</FormLabel>
//             <RadioGroup value={paymentMethod} onChange={onPaymentMethodChange}>
//               <FormControlLabel
//                 value="alfa"
//                 control={<Radio />}
//                 label={
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                     <CreditCardIcon color="primary" />
//                     <Box>
//                       <Typography variant="body1">Pay Online (Alfa)</Typography>
//                       <Typography variant="caption" color="text.secondary">
//                         Secure online payment via card/bank
//                       </Typography>
//                     </Box>
//                   </Box>
//                 }
//               />
//               <FormControlLabel
//                 value="safepay"
//                 control={<Radio />}
//                 label={
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                     <CreditCardIcon color="primary" />
//                     <Box>
//                       <Typography variant="body1">
//                         Pay Online (SafePay)
//                       </Typography>
//                       <Typography variant="caption" color="text.secondary">
//                         Secure online payment via card/bank
//                       </Typography>
//                     </Box>
//                   </Box>
//                 }
//               />
//               <FormControlLabel
//                 value="cash"
//                 control={<Radio />}
//                 label={
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                     <ReceiptIcon color="success" />
//                     <Box>
//                       <Typography variant="body1">
//                         Cash / Bank Transfer
//                       </Typography>
//                       <Typography variant="caption" color="text.secondary">
//                         Pay in cash and upload receipt
//                       </Typography>
//                     </Box>
//                   </Box>
//                 }
//               />
//             </RadioGroup>
//           </FormControl>

//           {/* Cash Receipt Upload */}
//           {paymentMethod === "cash" && (
//             <Box sx={{ mb: 2 }}>
//               <Typography variant="h6" gutterBottom fontWeight={700}>
//                 Bank Transfer Details
//               </Typography>

//               <Box
//                 sx={{
//                   p: 2,
//                   mb: 3,
//                   bgcolor: "#f8f9fa",
//                   border: "1px solid #e0e0e0",
//                   borderRadius: 2,
//                 }}
//               >
//                 <Typography variant="body2" sx={{ mb: 0.5 }}>
//                   <strong>Bank Name:</strong> Bank Alfalah
//                 </Typography>

//                 <Typography variant="body2" sx={{ mb: 0.5 }}>
//                   <strong>Account Title:</strong> OWNER TENANT SOLUTION
//                 </Typography>

//                 <Box
//                   display="flex"
//                   alignItems="center"
//                   gap={0.5}
//                   sx={{ mb: 0.5 }}
//                 >
//                   <Typography variant="body2">
//                     <strong>Account Number:</strong> 56365002910265
//                   </Typography>
//                   <IconButton
//                     size="small"
//                     onClick={() => copyToClipboard("56365002910265")}
//                     sx={{ color: "#1976d2", p: 0.3 }}
//                   >
//                     <ContentCopyIcon sx={{ fontSize: 14 }} />
//                   </IconButton>
//                 </Box>

//                 <Box
//                   display="flex"
//                   alignItems="center"
//                   gap={0.5}
//                   sx={{ mb: 1 }}
//                 >
//                   <Typography variant="body2">
//                     <strong>IBAN:</strong> PK52ALFH5636005002910265
//                   </Typography>
//                   <IconButton
//                     size="small"
//                     onClick={() => copyToClipboard("PK52ALFH5636005002910265")}
//                     sx={{ color: "#1976d2", p: 0.3 }}
//                   >
//                     <ContentCopyIcon sx={{ fontSize: 14 }} />
//                   </IconButton>
//                 </Box>

//                 <Typography
//                   variant="body1"
//                   sx={{ fontWeight: 700, color: "text.primary" }}
//                 >
//                   <strong>Amount to Pay:</strong>{" "}
//                   {formatCurrency(
//                     paymentMethod === "safepay"
//                       ? Math.ceil(grandTotal / 0.9672)
//                       : paymentMethod === "alfa"
//                       ? Math.ceil(grandTotal + grandTotal * 0.025)
//                       : grandTotal
//                   )}
//                 </Typography>
//               </Box>

//               {/* --- NEW DESIGN BASED ON SECOND IMAGE --- */}
//               {/* Dark Header/Notice container */}
//               <Box
//                 sx={{
//                   bgcolor: "#2c2c2c",
//                   color: "white",
//                   p: 2,
//                   borderRadius: "8px 8px 0 0",
//                   display: "flex",
//                   alignItems: "flex-start",
//                   gap: 1.5,
//                 }}
//               >
//                 <ErrorOutlineIcon sx={{ color: "#ff8a80", mt: 0.3 }} />
//                 <Box>
//                   <Typography
//                     variant="subtitle1"
//                     fontWeight={700}
//                     sx={{ lineHeight: 1.2 }}
//                   >
//                     Important notice — cash / bank transfer
//                   </Typography>
//                   <Typography variant="caption" sx={{ color: "#aaa" }}>
//                     Read carefully before proceeding
//                   </Typography>
//                 </Box>
//               </Box>

//               {/* Light Pink Warnings Body */}
//               <Box
//                 sx={{
//                   bgcolor: "#fbebe9",
//                   p: 2.5,
//                   borderRadius: "0 0 8px 8px",
//                   border: "1px solid #f8d7da",
//                   borderTop: "none",
//                   mb: 2,
//                 }}
//               >
//                 <Typography
//                   variant="body2"
//                   sx={{ color: "#58181c", fontWeight: 600, mb: 2 }}
//                 >
//                   By choosing to pay via cash or direct bank transfer, you
//                   acknowledge and agree to the following:
//                 </Typography>

//                 <Stack spacing={1.5}>
//                   <Box display="flex" alignItems="flex-start" gap={1.5}>
//                     <CancelIcon
//                       sx={{ color: "#b03a2e", fontSize: 18, mt: 0.2 }}
//                     />
//                     <Typography variant="body2" sx={{ color: "#58181c" }}>
//                       Owner Tenant Solution (OTS) is{" "}
//                       <strong>not responsible</strong> for any payment made
//                       directly to the property owner outside this platform.
//                     </Typography>
//                   </Box>

//                   <Box display="flex" alignItems="flex-start" gap={1.5}>
//                     <CancelIcon
//                       sx={{ color: "#b03a2e", fontSize: 18, mt: 0.2 }}
//                     />
//                     <Typography variant="body2" sx={{ color: "#58181c" }}>
//                       Once funds are transferred to the owner's account, OTS has{" "}
//                       <strong>no authority</strong> to recover, hold, or
//                       intervene in that transaction.
//                     </Typography>
//                   </Box>

//                   <Box display="flex" alignItems="flex-start" gap={1.5}>
//                     <CancelIcon
//                       sx={{ color: "#b03a2e", fontSize: 18, mt: 0.2 }}
//                     />
//                     <Typography variant="body2" sx={{ color: "#58181c" }}>
//                       Our cancellation and refund policy does{" "}
//                       <strong>not apply</strong> to cash or direct transfer
//                       payments. Any refund is solely at the owner's discretion.
//                     </Typography>
//                   </Box>

//                   <Box display="flex" alignItems="flex-start" gap={1.5}>
//                     <CancelIcon
//                       sx={{ color: "#b03a2e", fontSize: 18, mt: 0.2 }}
//                     />
//                     <Typography variant="body2" sx={{ color: "#58181c" }}>
//                       This includes payments made via EasyPaisa, JazzCash, or
//                       any third-party wallet — these are treated as direct
//                       payments and carry <strong>no platform protection</strong>
//                       .
//                     </Typography>
//                   </Box>
//                 </Stack>
//               </Box>

//               {/* Recommendation Alert Box */}
//               <Box
//                 sx={{
//                   bgcolor: "#0f2d19",
//                   border: "1px solid #144d24",
//                   p: 2,
//                   borderRadius: 2,
//                   mb: 2,
//                   display: "flex",
//                   gap: 1.5,
//                   alignItems: "center",
//                 }}
//               >
//                 <ShieldOutlinedIcon sx={{ color: "#2ecc71" }} />
//                 <Typography
//                   variant="body2"
//                   sx={{ color: "#2ecc71", fontWeight: 500 }}
//                 >
//                   For full escrow protection and our refund guarantee, we
//                   recommend paying via{" "}
//                   <strong style={{ color: "#fff" }}>Alfa (Bank Alfalah)</strong>{" "}
//                   or <strong style={{ color: "#fff" }}>SafePay</strong>.
//                 </Typography>
//               </Box>

//               {/* Disclaimer Info Text Box */}
//               <Box sx={{ bgcolor: "#222", p: 2, borderRadius: 2, mb: 2 }}>
//                 <Typography
//                   variant="caption"
//                   sx={{ color: "#bbb", display: "block", lineHeight: 1.4 }}
//                 >
//                   By tapping <strong>"Submit Receipt"</strong> below, you
//                   confirm that you have read this notice and accept full
//                   responsibility for this payment. This acknowledgement is
//                   recorded against your booking.
//                 </Typography>
//               </Box>
//               {/* --- END OF NEW DESIGN --- */}

//               <Typography variant="subtitle2" gutterBottom fontWeight={600}>
//                 Upload Payment Receipt
//               </Typography>

//               <Button
//                 type="button"
//                 variant="outlined"
//                 component="label"
//                 startIcon={<CloudUploadIcon />}
//                 fullWidth
//                 sx={{
//                   mb: 2,
//                   borderRadius: 2,
//                   textTransform: "none",
//                   fontWeight: 600,
//                 }}
//               >
//                 {receiptImage ? "Change Receipt" : "Upload Receipt Image"}
//                 <input
//                   type="file"
//                   hidden
//                   accept="image/*"
//                   onChange={onReceiptUpload}
//                 />
//               </Button>

//               {receiptPreview && (
//                 <Box
//                   component="img"
//                   src={receiptPreview}
//                   alt="Receipt Preview"
//                   sx={{
//                     width: "100%",
//                     maxHeight: 200,
//                     objectFit: "contain",
//                     borderRadius: 2,
//                     border: "1px solid #ddd",
//                   }}
//                 />
//               )}
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 3 }}>
//           <Button
//             type="button"
//             onClick={onClose}
//             disabled={paymentLoading}
//             sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600 }}
//           >
//             Cancel
//           </Button>
//           {paymentMethod === "safepay" || paymentMethod === "alfa" ? (
//             <Button
//               type="button"
//               variant="contained"
//               color="primary"
//               onClick={
//                 paymentMethod === "safepay" ? onPayWithSafePay : onPayWithAlfa
//               }
//               disabled={paymentLoading || !settingsLoaded || settingsLoading}
//               startIcon={
//                 paymentLoading ? (
//                   <CircularProgress size={20} />
//                 ) : (
//                   <CreditCardIcon />
//                 )
//               }
//               sx={{
//                 borderRadius: 2,
//                 textTransform: "none",
//                 fontWeight: 600,
//                 px: 3,
//               }}
//             >
//               Pay Now
//             </Button>
//           ) : (
//             <Button
//               type="button"
//               variant="contained"
//               color="success"
//               onClick={onSubmitReceipt}
//               disabled={paymentLoading || !receiptImage}
//               startIcon={
//                 paymentLoading ? (
//                   <CircularProgress size={20} />
//                 ) : (
//                   <CloudUploadIcon />
//                 )
//               }
//               sx={{
//                 borderRadius: 2,
//                 textTransform: "none",
//                 fontWeight: 600,
//                 px: 3,
//               }}
//             >
//               Submit Receipt
//             </Button>
//           )}
//         </DialogActions>
//       </Dialog>
//       <ToastContainer
//         position="top-right"
//         autoClose={3000}
//         hideProgressBar={false}
//         newestOnTop
//         closeOnClick
//         pauseOnHover
//         theme="colored"
//       />
//     </>
//   );
// };

// export default PaymentDialog;
import React from "react";
import CancellationPolicyBox from "../../../components/CancellationPolicyBox";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Alert,
  Paper,
  Box,
  CircularProgress,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PaymentBreakdown from "../../../components/PaymentBreakdown";
import {
  calculateAdvanceAndRentCommission,
  calculateAdvancePayment,
  formatCurrency,
} from "../../../utils/commissionCalculator";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton } from "@mui/material";
import { toast } from "react-toastify";
import { Stack } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CancelIcon from '@mui/icons-material/Cancel';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const PaymentDialog = ({
  open,
  request,
  paymentMethod,
  onPaymentMethodChange,
  receiptImage,
  receiptPreview,
  onReceiptUpload,
  otsFeeReceiptImage,
  otsFeeReceiptPreview,
  onOtsFeeReceiptUpload,
  otsAccount,
  paymentError,
  paymentLoading,
  settingsLoaded,
  settingsLoading,
  customRates,
  onClose,
  onPayWithSafePay,
  onPayWithAlfa,
  onSubmitReceipt,
}) => {
  if (!request) return null;

  const advanceAmount = Number(request?.flatAdvance || 0);
  const rentAmount = Number(request?.flatRent || 0);
  const advanceBreakdown = calculateAdvanceAndRentCommission(
    advanceAmount,
    rentAmount,
    customRates
  );
  const grandTotal = advanceBreakdown.totalTenantPays;

  // Cash: the tenant pays the owner directly, so OTS only sees its own fee if
  // it is asked for separately. At 0% (or with the service switched off) there
  // is no fee, no OTS account to show and no second receipt.
  const otsFeeAmount = Number(advanceBreakdown.totalCommission) || 0;
  const cashOwnerAmount = grandTotal - otsFeeAmount;
  const feeApplies = otsFeeAmount > 0;
  const pct = (rate) => `${+((Number(rate) || 0) * 100).toFixed(2)}%`;
  const account = {
    bankName: otsAccount?.bankName || "Bank Alfalah",
    accountTitle: otsAccount?.accountTitle || "OWNER TENANT SOLUTION",
    accountNumber: otsAccount?.accountNumber || "56365002910265",
    iban: otsAccount?.iban || "PK52ALFH5636005002910265",
  };

  const copyToClipboard = (text) => {
    toast.success("Copied!");
    navigator.clipboard.writeText(text);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
          },
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Typography variant="h6" fontWeight={700}>
            Make Payment
          </Typography>
        </DialogTitle>
        <DialogContent>
          {paymentError && (
            <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>
              {paymentError}
            </Alert>
          )}

          {/* Flat Info */}
          <Paper
            elevation={0}
            sx={{ bgcolor: "#f5f5f5", p: 2, borderRadius: 2, mb: 3 }}
          >
            <Typography variant="subtitle1" fontWeight={600}>
              {request?.flatName}
            </Typography>
          </Paper>

          {/* Loading indicator */}
          {(!settingsLoaded || settingsLoading) && (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularProgress />
            </Box>
          )}

          {/* Payment Breakdown */}
          {settingsLoaded && !settingsLoading && (
            <Box sx={{ mb: 3 }}>
              <PaymentBreakdown
                baseAmount={advanceAmount}
                commissionAmount={advanceBreakdown.commissionAmount}
                commissionPercentage={advanceBreakdown.commissionPercentage}
                lateFee={0}
                totalAmount={advanceBreakdown.totalTenantPays}
                landlordReceives={advanceBreakdown.landlordReceives}
                type="advance"
                isLate={false}
                daysOverdue={0}
                paymentMethod={paymentMethod}
              />

              <Paper
                elevation={0}
                sx={{
                  border: "1px solid #e0e0e0",
                  borderRadius: 2,
                  p: 2,
                  mt: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="body1">First Month Rent</Typography>
                  <Typography variant="body1" fontWeight={600}>
                    {formatCurrency(rentAmount)}
                  </Typography>
                </Box>
              </Paper>

              {paymentMethod === "safepay" && (
                <Paper
                  elevation={0}
                  sx={{
                    border: "1px solid #e0e0e0",
                    borderRadius: 2,
                    p: 2,
                    mt: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="body1">
                      SafePay Processing Fee
                    </Typography>
                    <Typography variant="body1" fontWeight={600}>
                      3.28%
                    </Typography>
                  </Box>
                </Paper>
              )}
              {paymentMethod === "alfa" && (
                <Paper
                  elevation={0}
                  sx={{
                    border: "1px solid #e0e0e0",
                    borderRadius: 2,
                    p: 2,
                    mt: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="body1">Alfa Processing Fee</Typography>
                    <Typography variant="body1" fontWeight={600}>
                      2.5%
                    </Typography>
                  </Box>
                </Paper>
              )}

              <Paper
                elevation={0}
                sx={{
                  bgcolor: "primary.main",
                  color: "white",
                  p: 2,
                  borderRadius: 2,
                  mt: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="h6" fontWeight={600}>
                    Grand Total
                  </Typography>
                  <Typography variant="h5" fontWeight={700}>
                    {formatCurrency(
                      paymentMethod === "safepay"
                        ? Math.ceil(grandTotal / 0.9672)
                        : paymentMethod === "alfa"
                        ? Math.ceil(grandTotal + grandTotal * 0.025)
                        : grandTotal
                    )}
                  </Typography>
                </Box>
              </Paper>
            </Box>
          )}

          {/* Payment Method Selection */}
          <FormControl component="fieldset" sx={{ mb: 3 }}>
            <FormLabel component="legend">Choose Payment Method</FormLabel>
            <RadioGroup value={paymentMethod} onChange={onPaymentMethodChange}>
              {/* <FormControlLabel
                value="alfa"
                control={<Radio />}
                label={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CreditCardIcon color="primary" />
                    <Box>
                      <Typography variant="body1">Pay Online (Alfa)</Typography>
                      <Typography variant="caption" color="text.secondary">
                        Secure online payment via card/bank
                      </Typography>
                    </Box>
                  </Box>
                }
              />
              <FormControlLabel
                value="safepay"
                control={<Radio />}
                label={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CreditCardIcon color="primary" />
                    <Box>
                      <Typography variant="body1">
                        Pay Online (SafePay)
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Secure online payment via card/bank
                      </Typography>
                    </Box>
                  </Box>
                }
              /> */}
              <FormControlLabel
                value="cash"
                control={<Radio />}
                label={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <ReceiptIcon color="success" />
                    <Box>
                      <Typography variant="body1">
                        Cash / Bank Transfer
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Pay in cash and upload receipt
                      </Typography>
                    </Box>
                  </Box>
                }
              />
            </RadioGroup>
          </FormControl>

          {/* --- ALFA DETAILS SECTION --- */}
          {paymentMethod === "alfa" && (
            <Box sx={{ mb: 2 }}>
              <Box
                sx={{
                  bgcolor: "#0f2d19",
                  color: "white",
                  p: 2,
                  borderRadius: "8px 8px 0 0",
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 1.5,
                }}
              >
                <ShieldOutlinedIcon sx={{ color: "#2ecc71", mt: 0.3 }} />
                <Box>
                  <Typography variant="subtitle1" fontWeight={700} sx={{ lineHeight: 1.2 }}>
                    Pay Online — Alfa (Bank Alfalah)
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#2ecc71" }}>
                    Fully protected secure payment gateway
                  </Typography>
                </Box>
              </Box>

              <Box
                sx={{
                  bgcolor: "#fafafa",
                  p: 2.5,
                  borderRadius: "0 0 8px 8px",
                  border: "1px solid #e0e0e0",
                  borderTop: "none",
                  mb: 2,
                }}
              >
                <Stack spacing={1.5} sx={{ mb: 2 }}>
                  <Box display="flex" alignItems="center" gap={1.5}>
                    <CheckCircleOutlineIcon sx={{ color: "#2ecc71", fontSize: 18 }} />
                    <Typography variant="body2" color="text.secondary">
                      Your payment is held by OTS. The owner can claim their share only after the refund period below ends, or once you move in. If you cancel within the refund period you are refunded as shown; after it ends, no refund is due.
                    </Typography>
                  </Box>
                  <Box display="flex" alignItems="center" gap={1.5}>
                    <CheckCircleOutlineIcon sx={{ color: "#2ecc71", fontSize: 18 }} />
                    <Typography variant="body2" color="text.secondary">
                      Full transaction record maintained on the platform — dispute resolution supported.
                    </Typography>
                  </Box>
                </Stack>

                <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ display: "block", mb: 1, textTransform: "uppercase", letterSpacing: 0.5 }}>
                  CANCELLATION & REFUND POLICY
                </Typography>

                <CancellationPolicyBox />
              </Box>
            </Box>
          )}

          {/* --- SAFEPAY DETAILS SECTION --- */}
          {paymentMethod === "safepay" && (
            <Box sx={{ mb: 2 }}>
              <Box
                sx={{
                  bgcolor: "#1a365d",
                  color: "white",
                  p: 2,
                  borderRadius: "8px 8px 0 0",
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 1.5,
                }}
              >
                <ShieldOutlinedIcon sx={{ color: "#63b3ed", mt: 0.3 }} />
                <Box>
                  <Typography variant="subtitle1" fontWeight={700} sx={{ lineHeight: 1.2 }}>
                    Pay Online — SafePay Secure
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#63b3ed" }}>
                    Instant activation & complete escrow coverage
                  </Typography>
                </Box>
              </Box>

              <Box
                sx={{
                  bgcolor: "#fafafa",
                  p: 2.5,
                  borderRadius: "0 0 8px 8px",
                  border: "1px solid #e0e0e0",
                  borderTop: "none",
                  mb: 2,
                }}
              >
                <Stack spacing={1.5}>
                  <Box display="flex" alignItems="flex-start" gap={1.5}>
                    <CheckCircleOutlineIcon sx={{ color: "#3182ce", fontSize: 18, mt: 0.2 }} />
                    <Typography variant="body2" color="text.secondary">
                      <strong>Payment Protection:</strong> Your payment is held by OTS. The owner can claim it only after the refund period below ends, or once you have moved in.
                    </Typography>
                  </Box>
                  <Box display="flex" alignItems="flex-start" gap={1.5}>
                    <CheckCircleOutlineIcon sx={{ color: "#3182ce", fontSize: 18, mt: 0.2 }} />
                    <Typography variant="body2" color="text.secondary">
                      <strong>Fraud Shield:</strong> Automated 3D Secure verification guards your debit/credit cards against unauthorized access.
                    </Typography>
                  </Box>
                  <Box display="flex" alignItems="flex-start" gap={1.5}>
                    <CheckCircleOutlineIcon sx={{ color: "#3182ce", fontSize: 18, mt: 0.2 }} />
                    <Typography variant="body2" color="text.secondary">
                      <strong>Clear Refund Rules:</strong> If you cancel within the refund period, you are refunded as shown below. After it ends, no refund is due.
                    </Typography>
                  </Box>
                </Stack>

                <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ display: "block", mt: 2, mb: 1, textTransform: "uppercase", letterSpacing: 0.5 }}>
                  CANCELLATION & REFUND POLICY
                </Typography>
                <CancellationPolicyBox />
              </Box>
            </Box>
          )}

          {/* Cash / Bank Transfer Details */}
          {paymentMethod === "cash" && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="h6" gutterBottom fontWeight={700}>
                {feeApplies ? "How to pay" : "Pay the owner"}
              </Typography>

              {/* Step 1 — the owner. Always present. */}
              <Box
                sx={{
                  p: 2,
                  mb: 2,
                  bgcolor: "#f8f9fa",
                  border: "1px solid #e0e0e0",
                  borderRadius: 2,
                }}
              >
                <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 700 }}>
                  {feeApplies ? "1. Pay the owner" : "Pay the owner directly"}
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 700 }}>
                  {formatCurrency(feeApplies ? cashOwnerAmount : grandTotal)}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {feeApplies
                    ? "Advance + first month's rent, in cash or by transfer to the owner. Keep the receipt."
                    : "Advance + first month's rent, in cash or by transfer to the owner. Keep the receipt — there is no OTS service fee on this booking."}
                </Typography>
              </Box>

              {/* Step 2 — OTS's own fee, only when there is one. */}
              {feeApplies && (
                <Box
                  sx={{
                    p: 2,
                    mb: 3,
                    bgcolor: "#f8f9fa",
                    border: "1px solid #e0e0e0",
                    borderRadius: 2,
                  }}
                >
                  <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 700 }}>
                    2. Pay the OTS service fee to OTS
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 700 }}>
                    {formatCurrency(otsFeeAmount)}
                  </Typography>
                  <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1.5 }}>
                    {pct(customRates?.ADVANCE)} of the advance + {pct(customRates?.MONTHLY_RENT)} of
                    the first month's rent. This goes to OTS's own account below, not to the owner.
                    An OTS admin checks this receipt before your tenancy can start.
                  </Typography>

                  <Typography variant="body2" sx={{ mb: 0.5 }}>
                    <strong>Bank Name:</strong> {account.bankName}
                  </Typography>

                  <Typography variant="body2" sx={{ mb: 0.5 }}>
                    <strong>Account Title:</strong> {account.accountTitle}
                  </Typography>

                  <Box display="flex" alignItems="center" gap={0.5} sx={{ mb: 0.5 }}>
                    <Typography variant="body2">
                      <strong>Account Number:</strong> {account.accountNumber}
                    </Typography>
                    <IconButton
                      size="small"
                      onClick={() => copyToClipboard(account.accountNumber)}
                      sx={{ color: "#1976d2", p: 0.3 }}
                    >
                      <ContentCopyIcon sx={{ fontSize: 14 }} />
                    </IconButton>
                  </Box>

                  <Box display="flex" alignItems="center" gap={0.5}>
                    <Typography variant="body2">
                      <strong>IBAN:</strong> {account.iban}
                    </Typography>
                    <IconButton
                      size="small"
                      onClick={() => copyToClipboard(account.iban)}
                      sx={{ color: "#1976d2", p: 0.3 }}
                    >
                      <ContentCopyIcon sx={{ fontSize: 14 }} />
                    </IconButton>
                  </Box>
                </Box>
              )}

              {/* Dark Header/Notice container */}
              <Box
                sx={{
                  bgcolor: "#2c2c2c",
                  color: "white",
                  p: 2,
                  borderRadius: "8px 8px 0 0",
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 1.5,
                }}
              >
                <ErrorOutlineIcon sx={{ color: "#ff8a80", mt: 0.3 }} />
                <Box>
                  <Typography variant="subtitle1" fontWeight={700} sx={{ lineHeight: 1.2 }}>
                    Important notice — cash / bank transfer
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#aaa" }}>
                    Read carefully before proceeding
                  </Typography>
                </Box>
              </Box>

              {/* Light Pink Warnings Body */}
              <Box
                sx={{
                  bgcolor: "#fbebe9",
                  p: 2.5,
                  borderRadius: "0 0 8px 8px",
                  border: "1px solid #f8d7da",
                  borderTop: "none",
                  mb: 2,
                }}
              >
                <Typography variant="body2" sx={{ color: "#58181c", fontWeight: 600, mb: 2 }}>
                  By choosing to pay via cash or direct bank transfer, you acknowledge and agree to the following:
                </Typography>

                <Stack spacing={1.5}>
                  <Box display="flex" alignItems="flex-start" gap={1.5}>
                    <CancelIcon sx={{ color: "#b03a2e", fontSize: 18, mt: 0.2 }} />
                    <Typography variant="body2" sx={{ color: "#58181c" }}>
                      Owner Tenant Solution (OTS) is <strong>not responsible</strong> for any payment made directly to the property owner outside this platform.
                    </Typography>
                  </Box>

                  <Box display="flex" alignItems="flex-start" gap={1.5}>
                    <CancelIcon sx={{ color: "#b03a2e", fontSize: 18, mt: 0.2 }} />
                    <Typography variant="body2" sx={{ color: "#58181c" }}>
                      Once funds are transferred to the owner's account, OTS has <strong>no authority</strong> to recover, hold, or intervene in that transaction.
                    </Typography>
                  </Box>

                  <Box display="flex" alignItems="flex-start" gap={1.5}>
                    <CancelIcon sx={{ color: "#b03a2e", fontSize: 18, mt: 0.2 }} />
                    <Typography variant="body2" sx={{ color: "#58181c" }}>
                      Our cancellation and refund policy does <strong>not apply</strong> to cash or direct transfer payments. Any refund is solely at the owner's discretion.
                    </Typography>
                  </Box>

                  <Box display="flex" alignItems="flex-start" gap={1.5}>
                    <CancelIcon sx={{ color: "#b03a2e", fontSize: 18, mt: 0.2 }} />
                    <Typography variant="body2" sx={{ color: "#58181c" }}>
                      This includes payments made via EasyPaisa, JazzCash, or any third-party wallet — these are treated as direct payments and carry <strong>no platform protection</strong>.
                    </Typography>
                  </Box>
                </Stack>
              </Box>

              {/* Recommendation Alert Box */}
              <Box
                sx={{
                  bgcolor: "#0f2d19",
                  border: "1px solid #144d24",
                  p: 2,
                  borderRadius: 2,
                  mb: 2,
                  display: "flex",
                  gap: 1.5,
                  alignItems: "center",
                }}
              >
                <ShieldOutlinedIcon sx={{ color: "#2ecc71" }} />
                <Typography variant="body2" sx={{ color: "#2ecc71", fontWeight: 500 }}>
                  For full escrow protection and our refund guarantee, we recommend paying via <strong style={{ color: "#fff" }}>Alfa (Bank Alfalah)</strong> or <strong style={{ color: "#fff" }}>SafePay</strong>.
                </Typography>
              </Box>

              {/* Disclaimer Info Text Box */}
              <Box sx={{ bgcolor: "#222", p: 2, borderRadius: 2, mb: 2 }}>
                <Typography variant="caption" sx={{ color: "#bbb", display: "block", lineHeight: 1.4 }}>
                  By tapping <strong>"Submit Receipt"</strong> below, you confirm that you have read this notice and accept full responsibility for this payment. This acknowledgement is recorded against your booking.
                </Typography>
              </Box>

              <Typography variant="subtitle2" gutterBottom fontWeight={600}>
                {feeApplies ? "1. Receipt of your payment to the owner" : "Upload Payment Receipt"}
              </Typography>

              <Button
                type="button"
                variant="outlined"
                component="label"
                startIcon={<CloudUploadIcon />}
                fullWidth
                sx={{
                  mb: 2,
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                {receiptImage ? "Change Receipt" : "Upload Receipt Image"}
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={onReceiptUpload}
                />
              </Button>

              {receiptPreview && (
                <Box
                  component="img"
                  src={receiptPreview}
                  alt="Receipt Preview"
                  sx={{
                    width: "100%",
                    maxHeight: 200,
                    objectFit: "contain",
                    borderRadius: 2,
                    border: "1px solid #ddd",
                    mb: 2,
                  }}
                />
              )}

              {feeApplies && (
                <>
                  <Typography variant="subtitle2" gutterBottom fontWeight={600} sx={{ mt: 1 }}>
                    2. Receipt of your OTS service fee payment
                  </Typography>

                  <Button
                    type="button"
                    variant="outlined"
                    component="label"
                    startIcon={<CloudUploadIcon />}
                    fullWidth
                    sx={{
                      mb: 2,
                      borderRadius: 2,
                      textTransform: "none",
                      fontWeight: 600,
                    }}
                  >
                    {otsFeeReceiptImage ? "Change OTS Fee Receipt" : "Upload OTS Fee Receipt"}
                    <input
                      type="file"
                      hidden
                      accept="image/*"
                      onChange={onOtsFeeReceiptUpload}
                    />
                  </Button>

                  {otsFeeReceiptPreview && (
                    <Box
                      component="img"
                      src={otsFeeReceiptPreview}
                      alt="OTS Fee Receipt Preview"
                      sx={{
                        width: "100%",
                        maxHeight: 200,
                        objectFit: "contain",
                        borderRadius: 2,
                        border: "1px solid #ddd",
                      }}
                    />
                  )}
                </>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button
            type="button"
            onClick={onClose}
            disabled={paymentLoading}
            sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600 }}
          >
            Cancel
          </Button>
          {paymentMethod === "safepay" || paymentMethod === "alfa" ? (
            <Button
              type="button"
              variant="contained"
              color="primary"
              onClick={
                paymentMethod === "safepay" ? onPayWithSafePay : onPayWithAlfa
              }
              disabled={paymentLoading || !settingsLoaded || settingsLoading}
              startIcon={
                paymentLoading ? (
                  <CircularProgress size={20} />
                ) : (
                  <CreditCardIcon />
                )
              }
              sx={{
                borderRadius: 2,
                textTransform: "none",
                fontWeight: 600,
                px: 3,
              }}
            >
              Pay Now
            </Button>
          ) : (
            <Button
              type="button"
              variant="contained"
              color="success"
              onClick={onSubmitReceipt}
              disabled={
                paymentLoading ||
                !receiptImage ||
                (feeApplies && !otsFeeReceiptImage)
              }
              startIcon={
                paymentLoading ? (
                  <CircularProgress size={20} />
                ) : (
                  <CloudUploadIcon />
                )
              }
              sx={{
                borderRadius: 2,
                textTransform: "none",
                fontWeight: 600,
                px: 3,
              }}
            >
              Submit Receipt
            </Button>
          )}
        </DialogActions>
      </Dialog>
      {/* The container lives on MyRequests now. It used to sit here, which
          meant toasts only worked while this dialog was open — everything else
          on the page fired into nothing, because `if (!request) return null`
          unmounts the container the moment the dialog closes. */}
    </>
  );
};

export default PaymentDialog;